import { forwardRef } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const IconBookmarkFilled_16 = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 16 16"
    data-fill-none
  >
    <path
      d="M11.9325 14.8195L8.00004 12.0668L4.0676 14.8195C3.99768 14.8684 3.91569 14.8972 3.83053 14.9028C3.74538 14.9084 3.66033 14.8905 3.58463 14.8511C3.50893 14.8117 3.44548 14.7523 3.40118 14.6794C3.35688 14.6064 3.33343 14.5228 3.33337 14.4374V2.26675C3.33337 2.01922 3.43171 1.78182 3.60674 1.60679C3.78177 1.43175 4.01917 1.33342 4.26671 1.33342H11.7334C11.9809 1.33342 12.2183 1.43175 12.3933 1.60679C12.5684 1.78182 12.6667 2.01922 12.6667 2.26675V14.4374C12.6667 14.5228 12.6432 14.6064 12.5989 14.6794C12.5546 14.7523 12.4911 14.8117 12.4154 14.8511C12.3397 14.8905 12.2547 14.9084 12.1695 14.9028C12.0844 14.8972 12.0024 14.8684 11.9325 14.8195Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="currentColor"
    />
  </SvgIcon>
));
IconBookmarkFilled_16.displayName = 'IconBookmarkFilled_16';
